export default "/images/60ea791838c94367768695787de4ac4d.png";